import React, { cloneElement } from 'react';

import { isMobile } from 'styles/utils';
import { Step } from './Step';

import type { StepIndicatorProps, StepProps } from './types';

const StepIndicator = ({
  children,
  activeStepKey,
  className,
  onStepClick,
  hiddenStepKeys,
}: StepIndicatorProps) => {
  let index = 1;

  return (
    <div className={`flex h-3/5 justify-between  ${className}`}>
      {React.Children.map(children, child => {
        const shouldHideOnMobile =
          isMobile() &&
          React.isValidElement<StepProps>(child) &&
          child.key !== activeStepKey;

        if (React.isValidElement<StepProps>(child) && child.type === Step) {
          if (hiddenStepKeys?.length && hiddenStepKeys.includes(child.key)) {
            return null;
          }

          const element = cloneElement(child, {
            isActive: child.key === activeStepKey,
            index,
            onStepClick: () => {
              if (onStepClick) {
                onStepClick(child.key);
              }
            },
          });

          index += 1;

          return shouldHideOnMobile ? null : element;
        }

        return child;
      })}
    </div>
  );
};

export { StepIndicator };
